import { type ReactElement, useState } from "react";
import { FeatureFlagNamesEnum } from "src/graphql/generated/types";
import { useCurrentAccount, useHasFeatureFlagActivated } from "src/hooks";

import { ConsentPlatformModal } from "./consent-platform-modal";

type Props = {
  defaultForm: ReactElement;
};

export function ConsentPlatformGate({ defaultForm }: Props): ReactElement {
  const { customer } = useCurrentAccount();
  const hasConsentPlatform = useHasFeatureFlagActivated(
    FeatureFlagNamesEnum.CustomerPortalConsentPlatform,
  );
  const [dismissedCustomerId, setDismissedCustomerId] = useState<string>();

  if (!hasConsentPlatform) {
    return defaultForm;
  }

  const hasLocalPreview =
    import.meta.env.DEV &&
    new URLSearchParams(window.location.search).get("previewConsent") ===
      "true";
  // TODO(ML-27245): replace the first-submission rule when existing-customer eligibility is available.
  const shouldRequestConsent =
    !customer.confidentiality.isFirstSubmit || hasLocalPreview;

  return (
    <ConsentPlatformModal
      key={customer.id}
      open={shouldRequestConsent && dismissedCustomerId !== customer.id}
      firstName={customer.firstName ?? ""}
      onComplete={() => {
        // TODO(ML-27245): persist the selected purposes and channels when the OneTrust contract is available.
        setDismissedCustomerId(customer.id);
      }}
    />
  );
}
